import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import { API } from '../App';
import { isAllowed } from '../lib/cookieConsent';

// Generate or retrieve a session ID
const getSessionId = () => {
  let sessionId = sessionStorage.getItem('thyroid_session_id');
  if (!sessionId) {
    sessionId = `sess_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    sessionStorage.setItem('thyroid_session_id', sessionId);
  }
  return sessionId;
};

export default function usePageTracking() {
  const location = useLocation();
  const prevPath = useRef(null);

  useEffect(() => {
    // Only track if the path actually changed
    if (prevPath.current === location.pathname) {
      return;
    }
    prevPath.current = location.pathname;

    // Don't track admin pages
    if (location.pathname.startsWith('/admin')) {
      return;
    }

    // Respect cookie consent — only track if user opted into analytics cookies.
    if (!isAllowed('analytics')) {
      return;
    }

    // Track the page view
    const trackPageView = async () => {
      try {
        await axios.post(`${API}/track/pageview`, {
          page: location.pathname,
          referrer: document.referrer || null,
          user_agent: navigator.userAgent,
          session_id: getSessionId()
        });
      } catch (error) {
        // Silently fail - don't impact user experience
        console.debug('Page tracking failed:', error.message);
      }
    };

    trackPageView();
  }, [location.pathname]);
}
